<template>
  <div class="qpp-margin-sides-5pc">
    <div class="action-container">
    <slot name="actions" />
    </div>
  </div>
  <slot />
</template>

<script>

export default {
  name: "ReportTemplate",
};
</script>

<style scoped>

.action-container {
  min-width: 400px;
  width: 35%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 50px;
}

</style>
